import { render, staticRenderFns } from "./SimplePieChart.vue?vue&type=template&id=12d69ac8"
import script from "./SimplePieChart.vue?vue&type=script&lang=js"
export * from "./SimplePieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports